import React, { FC } from 'react';
import { Button } from 'antd';

// Inline rather than Tailwind on purpose: antd's `.ant-btn-link` sets its own border colour and
// padding, and inline styles are what reliably win over it. These values are the ones every
// table/section footer already used before this was extracted.
const SEE_ALL_BUTTON_STYLE: React.CSSProperties = {
	width: '100%',
	borderBottomLeftRadius: 4,
	borderBottomRightRadius: 4,
	padding: 12,
	height: 40,
	borderTop: '1px solid #e8e8e8',
	textAlign: 'center',
};

interface SeeAllButtonProps {
	onClick: () => void;
}

/** Full-width "See all" link footer under a truncated list. */
export const SeeAllButton: FC<SeeAllButtonProps> = ({ onClick }) => (
	<Button onClick={onClick} type="link" style={SEE_ALL_BUTTON_STYLE}>
		See all
	</Button>
);
